import { Row, Container } from 'react-bootstrap';
import Styles from './aboutus.module.scss';
import aboutUsImage from '../../../assets/aboutUsImage.jpg';
import logo from '../../../assets/logo.webp';
import pic1 from '../../../assets/ayesha.jfif';
import pic2 from '../../../assets/user2.jpeg';
import pic3 from '../../../assets/wajeeha.jfif';

const AboutUs = () => {
	return (
		<div className={Styles.container}>
			<Row className={Styles.header}>
				<div className={Styles.slogan}>
					<h1>AirAI Elevates Atmosphere</h1>
				</div>
				<div className={Styles.aboutUsImage}>
					<img src={aboutUsImage} alt="about us" />
				</div>
			</Row>
			<Container className={Styles.cont}>
				<h1>About AirAI</h1>
				<Row className={Styles.founder}>
					<div className={Styles.logo}><img src={logo} alt="" /></div>
					<div className={Styles.text}>
					<p>Amidst the era of advancing technology, We came to realize the pressing need for a
                            revolutionary solution in the domain of air quality monitoring.
                            Observing the environmental challenges we face today, the AirAI project was born.
                        <br />
                        Harnessing the power of satellite technology and artificial intelligence, AirAI is not just a
                        project; it's a commitment to transforming the way we perceive and interact with our surroundings.
                        Through real-time data integration and dynamic visual mapping, AirAI provides an unprecedented
                        insight into air quality, empowering
                        individuals and communities to make informed decisions for a healthier future.</p>
					</div>
				</Row>
				
				<div className={Styles.faculty}>
					<h1>OurTeam of Talented Individuals</h1>
					
					<Row className={Styles.pictures}>
						<div className={Styles.pic}>
							<img src={pic1} alt="" />
							<h3>Ayesha Inam</h3>
							<p>Frontend developer and ML Engineer</p>
						</div>
						<div className={Styles.pic}>
							<img src={pic2} alt="" />
							<h3>Fatima Kashif</h3>
							<p>Backend developer and ML Engineer</p>
						</div>
						<div className={Styles.pic}>
							<img src={pic3} alt="" />
							<h3>Wajeeha Aftab</h3>
							<p>Frontend developer and ML Engineer</p>
						</div>
						
					</Row>
				</div>
			</Container>
		</div>
	);
};
export { AboutUs };
